<template>
	<div class="product-cross-promo__component u-mrg-btm">
		<div v-if="loading" class="u-padd-top u-padd-btm u-padd-left u-padd-right u-flex u-flex--justify-center">
			<img :src="'/assets/toolkit/images/Loading_Animation.gif'" />
		</div>
		<p v-if="!loading">
			<span v-if="!$props.productGrouping">Showing <span class=" "><strong>{{ totalItems }}</strong>
					Products</span></span>
			<span v-if="$props.productGrouping && $props.productGrouping !== ''">{{ $props.productGrouping }} &mdash;
				<span class=""><strong>{{ totalItems }}</strong> Products</span></span>
		</p>
		<div class="fx-grid">
			<product-cross-promo-item v-for="(product, index) in filteredItems" :key="index" :item="product"
				:use="$props.use"></product-cross-promo-item>
		</div>
		<button v-if="totalItems != 0 && totalShowing < totalItems"
			class="load-more u-txt-center u-mrg-top-half u-mrg-btm-half u-padd-all-qtr cursor-pointer w100 btn btn--primary pagination__next"
			@click="loadMore();">Load More</button>
		<div v-if="totalItems != 0 && totalShowing < totalItems" @click="viewAll();" class="u-txt-center">
			<a class="link link-cta cursor-pointer" tabindex="0" @click="viewAll();">View All</a>
		</div>
		<div v-if="totalItems == 0 && filter != ''" class="u-txt-center no-items-to-show">
			Sorry, no items matched your search.
		</div>
	</div>
</template>

<script>
import axios from "axios";
import ProductCrossPromoItem from "./ProductCrossPromoItem.vue";
export default {
	name: 'ProductListing',
	components: { ProductCrossPromoItem },

	data() {
		return {
			products: [],
			selectedItem: null,
			currentPage: 1,
			totalItems: null,
			totalShowing: 16,
			increment: 4,
			loading: true,
			searchFilter: "",
			refreshTrigger: 0
		};
	},
	created() {
		//or can pull path from a prop passed into the component
	},
	mounted() {

		var gallery = this.$props.productList[0];

		// var gallery = [];

		// for (var i = 0; i < this.$props.productList.length; i++) {
		// 	var list = this.$props.productList[i];

		// 	for (var j = 0; j < list.length; j++) {
		// 		gallery.push(list[j]);
		// 	}
		// }
		// for (var i = 0; i < this.$props.productList.length; i++) {
		// 	var list = this.$props.productList[i];

		// 	for (var j = 0; j < list.length; j++) {
		// 		gallery.push(list[j]);
		// 	}
		// }

		this.setGallery(gallery);
		this.getGalleryContent();
		this.loading = false;
		this.totalShowing = this.getTotalShowingItems();
		this.increment = this.getItemsIncrement();

		var input = $("#yonk-SearchBar-input--search-bar");

		if (input != null && input.length > 0) {

			var widget = this;

			input.on("search:apply", function () {
				//console.log("ProductList.vue: search:apply");
				widget.filterGallery(input.val());
			});

			input.on("search:clear", function () {
				//console.log("ProductList.vue: search:clear");
				widget.resetView();
			});
		}
	},
	props: {
		productList: Array,
		productGrouping: {
			type: String,
			default: ''
		},
		use: {
			type: String,
		}
	},
	methods: {
		resetView() {
			//console.log("resetView");
			this.currentPage = 1;

			var gallery = this.$props.productList[0];

			// var gallery = [];

			// for (var i = 0; i < this.$props.productList.length; i++) {
			// 	var list = this.$props.productList[i];

			// 	for (var j = 0; j < list.length; j++) {
			// 		gallery.push(list[j]);
			// 	}
			// }
			// for (var i = 0; i < this.$props.productList.length; i++) {
			// 	var list = this.$props.productList[i];

			// 	for (var j = 0; j < list.length; j++) {
			// 		gallery.push(list[j]);
			// 	}
			// }

			this.filter = "";
			this.setGallery(gallery);
			this.getGalleryContent();
			this.loading = false;
			this.totalShowing = this.getTotalShowingItems();
			this.increment = this.getItemsIncrement();
			//console.log(this);
			this.refreshTrigger++;
		},
		filterGallery(filterText) {
			this.filter = filterText;
			this.refreshTrigger++;
			let widget = this;
			setTimeout(function () {
				//console.log(`widget.totalShowing (${widget.totalShowing}) = widget.totalItems (${widget.totalItems})`);
				widget.totalShowing = widget.totalItems;
			}, 400);
		},
		setGallery(response) {
			this.products = response;
			this.totalItems = parseInt(response.length);
			this.getGalleryContent();
		},
		getGalleryContent() {
			this.loading = true;
		},
		loadMore() {
			if (this.totalShowing >= this.totalItems) return;
			this.totalShowing =
				this.totalShowing + this.increment >= this.totalItems
					? this.totalItems
					: this.totalShowing + this.increment;
		},
		viewAll() {
			this.totalShowing = this.totalItems;
		},
		getTotalShowingItems() {
			let result = 16;
			if (this.use === "newprod")
				result = 15;
			return result;
		},
		getItemsIncrement() {
			let result = 4;
			if (this.use === "newprod")
				result = 5;
			return result;
		}
	},
	computed: {
		filteredItems() {
			//console.log("filteredItems");
			let placeholderForRefresh = this.refreshTrigger;

			if (this.filter == null || this.filter == "") {
				//console.log("step 1");
				return this.products.slice(0, this.totalShowing).map((item) => {
					return item;
				});
			}
			else {
				//console.log("step 2");
				// tried to do some regex stuff didn't work very well
				// let fbuilder = "";
				// for (var i = 0; i < this.filter.length; i++) {
				// 	if (fbuilder != "")
				// 		fbuilder += "|";

				// 	for (var j = 0; j < this.filter.length; j++) {
				// 		if (i == j)
				// 			fbuilder += ".";
				// 		else
				// 			fbuilder += this.filter[j];
				// 	}
				// }
				// fbuilder = "/" + fbuilder + "|" + this.filter + "/i";
				// console.log(fbuilder);
				// //if (this.products[i].name.match(fbuilder)) {
				// if (product.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) {
				// 	gallery.push(product)
				// }

				let regexifyIt = function (str) {
					let fbuilder = "";
					for (var i = 0; i < str.length; i++) {
						if (fbuilder != "")
							fbuilder += "|";

						for (var j = 0; j < str.length; j++) {
							if (i == j && j != 0)
								fbuilder += ".";
							else
								fbuilder += str[j];
						}
					}
					fbuilder = fbuilder + "|" + str;
					//console.log(fbuilder);
					return new RegExp(fbuilder, "i");
				};

				let filterSplit = this.filter.split(" ");
				let filterList = [];

				for (var i = 0; i < filterSplit.length; i++) {
					filterSplit[i] = filterSplit[i].trim().toLowerCase();

					filterList.push({
						filterString: filterSplit[i],
						filterRegex: regexifyIt(filterSplit[i])
					});
				}

				let gallery = [];

				for (var i = 0; i < this.products.length; i++) {
					var product = this.products[i];
					var productName = product.name.toLowerCase().trim();

					var productWrapper = {
						product: product,
						matches: 0
					};

					for (var q = 0; q < filterList.length; q++) {

						let f = filterList[q];

						if (productName.indexOf(f.filterString) !== -1) {
							productWrapper.matches += 2;
						}
						else if (f.filterString.length > 2 && f.filterRegex.test(productName)) {
							productWrapper.matches += 1;
						}
					}

					if (productWrapper.matches > 0)
						gallery.push(productWrapper);
				}

				//console.log(gallery);

				let gallery2 = [];

				gallery.sort(function (a, b) {
					if (a.matches > b.matches) return -1;
					if (b.matches > a.matches) return 1;
					return a.product.name.localeCompare(b.product.name);
				});

				for (var p = 0; p < gallery.length; p++)
					gallery2.push(gallery[p].product);

				this.totalItems = gallery2.length;

				return gallery2;
			}
		},
	},
};
</script>
